import { Item, ItemSearch } from "@models/item";
import { buildItemSort, ItemSort, ITEM_BROWSE_PER_PAGE } from "@features/tickets/api/itemsBrowse.utils";
import { useSearchItemsBrowseQuery } from "@features/tickets/api/items.api";
import { useResourceBrowse } from "@features/tickets/shared/hooks/useResourceBrowse";
import { parseItemsUrlParams, syncItemsUrlParams } from "./itemsUrlParams";

export function useItemsBrowse() {
  const browse = useResourceBrowse<ItemSearch, Item, ItemSort>({
    parseBrowseUrlParams: parseItemsUrlParams,
    syncBrowseUrlParams: syncItemsUrlParams,
    buildSort: buildItemSort,
    useBrowseQuery: useSearchItemsBrowseQuery,
    defaultPerPage: ITEM_BROWSE_PER_PAGE,
  });

  return {
    itemSearchForm: browse.form,
    data: browse.data,
    isLoading: browse.isLoading,
    sortKey: browse.sortKey,
    sortMethod: browse.sortMethod,
    handleSortKeyChanged: browse.handleSortKeyChanged,
    handleSortMethodChanged: browse.handleSortMethodChanged,
    page: browse.page,
    perPage: browse.perPage,
    hasNextPage: browse.hasNextPage,
    hasPrevPage: browse.hasPrevPage,
    handleNextPage: browse.handleNextPage,
    handlePrevPage: browse.handlePrevPage,
    handleRowsPerPageChange: browse.handleRowsPerPageChange,
    reset: browse.reset,
  };
}
